import './HeroSection.css';
import { BrowserRouter,Routes,Route,NavLink,Link } from 'react-router-dom';
//assets import start here
import hero_section_img from './images/hero_image.png';
import hero_section_img2 from './images/hero_image2.png';
import hero_background from './images/hero.jpg';
import hero_background2 from './images/hero_image4.jpg';
import hero_img3 from  './images/img.jpeg';
//assets import ended here
export default function HeroSection(){
    return(
        <div className="HeroSection hero_section hero_section_parent_wrapper py-4">
          <div className="container hero_section_child_wrapper py-4">
            <div className="row text-center gy-3 hero_section_row d-flex justify-content-center align-items-center">
              <div className="col-12 col-sm-12 col-md-10 col-lg-10">
                <h6 className='hero_section_name'>
                  Hi there! I'm &nbsp;
                  <span>Rebaone</span>
                  <span>&nbsp;Matlaba</span>
                </h6>
                <h1 className='hero_section_caption font-weight-bolder mt-3'>
                  I'm a Multimedia Digital Designer and Software Engineer
                </h1>
                <p className="hero_section_description mt-3 text-white py-3 bg-dark">
                    Currently Doing Cool Things At 
                    <span className=''>&nbsp;
                      Astrum Peripherals As A Designer and Software Engineer 
                    </span>
                </p>
                <div className="buttons_wrapper d-flex justify-content-center mt-4 d-none">
                    <button className="btn btn-sm hero_section_contact text-white font-weight-bold px-4 py-2">
                        <Link className='text-white' to='/contact'><span>View Projects</span></Link>
                    </button>
                    <button className="btn btn-sm hero_section_build text-white font-weight-bold px-4 py-2">
                        <Link className='hero_section_build_text' to='/contact'><span>
                            Contact</span>
                        </Link>
                    </button>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <img src={hero_background2} alt="" className="img-fluid mx-auto" />
              </div>
            </div>
          </div>
        </div>
    );
}